import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AddTileToDigestTile } from './AddTileToDigestTile';
import { SingleTile } from './SingleTile';
import { EmptyTile } from './EmptyTile';

const emptyTilesAmount = (tileCount, tilesPerRow) => {
  const remainder = tileCount % tilesPerRow;

  return remainder !== 0 ? tilesPerRow - remainder : 0;
};

const TileList = ({
  activeFilters,
  activeStatus,
  addTileToDigest,
  canAddTile,
  changeTileStatus,
  handleMenuAction,
  hasEmptyTileFillers,
  isUserSiteAdmin,
  moveTileBackToPlan,
  moveTileToProof,
  tileDigestPlanDate,
  tiles,
  tilesPerRow,
}) => (
  <Fragment>
    {canAddTile && tiles.length === 0 && (
      <AddTileToDigestTile
        onClick={() => addTileToDigest(tileDigestPlanDate, tiles)}
      />
    )}
    {tiles.map((tile, index) => (
      <SingleTile
        key={index}
        tile={tile}
        index={index}
        activeStatus={activeStatus}
        changeTileStatus={changeTileStatus}
        handleMenuAction={handleMenuAction}
        isUserSiteAdmin={isUserSiteAdmin}
        activeFilters={activeFilters}
        moveTileBackToPlan={moveTileBackToPlan}
        moveTileToProof={moveTileToProof}
      />
    ))}
    {hasEmptyTileFillers &&
      [
        ...Array(
          emptyTilesAmount(tiles.length === 0 ? 1 : tiles.length, tilesPerRow),
        ).keys(),
      ].map((item, index) => (
        <EmptyTile key={`empty-${index}`} planDate={tileDigestPlanDate} />
      ))}
  </Fragment>
);

TileList.propTypes = {
  activeFilters: PropTypes.any,
  activeStatus: PropTypes.string,
  addTileToDigest: PropTypes.func,
  canAddTile: PropTypes.bool,
  changeTileStatus: PropTypes.func,
  handleMenuAction: PropTypes.func,
  hasEmptyTileFillers: PropTypes.bool,
  isUserSiteAdmin: PropTypes.bool,
  moveTileBackToPlan: PropTypes.func,
  moveTileToProof: PropTypes.func,
  tileContainerClick: PropTypes.func,
  tileDigestPlanDate: PropTypes.string,
  tiles: PropTypes.array,
  tilesPerRow: PropTypes.any,
};

const mapStateToProps = state => ({
  tilesPerRow: state.tilesPerRow,
});

export default connect(mapStateToProps)(TileList);
